const hideClass = "d-none"
class PaymentController {
  constructor() {
    this.paymentSourceSelect = $("#js-payment_method_select")[0]
    this.subscriptionForm = $("#js-subscription-form")[0]
    this.sepaForm = $("#js-sepa-payment-form")[0]
    this.creditCardForm = $("#js-card-payment-form")[0]
    this.couponInput = $("#js-coupon-input")[0]
    this.couponValidityMessage = $("#js-coupon-validity")[0]
    this.load()
  }

  load() {
    this.managePaymentSourceSelection()
    this.setupStripeElements()
    this.manageCouponValidity()
  }

  manageCouponValidity() {
    if (this.couponInput == undefined) {
      return
    }

    const self = this
    var validMessage = $(".success", this.couponValidityMessage)[0]
    var invalidMessage = $(".failure", this.couponValidityMessage)[0]

    this.couponInput.addEventListener("input", function (e) {
      if (e.target.value == "") {
        validMessage.classList.add(hideClass)
        invalidMessage.classList.add(hideClass)
      } else if (e.target.value == "SAM2021") {
        validMessage.classList.remove(hideClass)
        invalidMessage.classList.add(hideClass)
      } else if (e.target.value == "RESTART21") {
        validMessage.classList.remove(hideClass)
        invalidMessage.classList.add(hideClass)
      } else {
        validMessage.classList.add(hideClass)
        invalidMessage.classList.remove(hideClass)
      }
    })
  }

  managePaymentSourceSelection() {
    if (this.paymentSourceSelect == undefined) {
      return
    }

    if (this.subscriptionForm == undefined) {
      return
    }

    this._showSelectedPaymentSource()
    const self = this
    this.paymentSourceSelect.addEventListener("change", function () {
      self._showSelectedPaymentSource()
    })
  }

  _showSelectedPaymentSource() {
    var selectedPaymentSource =
      this.paymentSourceSelect.options[this.paymentSourceSelect.selectedIndex]
        .value

    $(".js-payment-source-form").hide()
    $("#" + selectedPaymentSource).show()
  }

  setupStripeElements() {
    if ($("#iban-element")[0] == undefined) {
      return
    }

    var stripeKey = $("#js-stripe-key").data("key")
    var stripe = Stripe(stripeKey)
    // Create an instance of Elements.
    var elements = stripe.elements()
    // console.log(elements)

    var style = {
      base: {
        color: "#32325d",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
        ":-webkit-autofill": {
          color: "#32325d",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
        ":-webkit-autofill": {
          color: "#fa755a",
        },
      },
    }

    var ibanOptions = {
      style: style,
      supportedCountries: ["SEPA"],
    }

    // Create Elements instance
    var iban = elements.create("iban", ibanOptions)
    var card = elements.create("card", {
      style: style,
    })

    // Add an instance of the iban Element into the `iban-element` <div>.
    iban.mount("#iban-element")
    console.log("iban is mounted", iban)
    card.mount("#card-element")

    iban.on("change", function (event) {
      var displayError = document.getElementById("sepa-errors")
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ""
      }
    })
    card.on("change", function (event) {
      var displayError = document.getElementById("card-errors")
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ""
      }
    })

    // Create a source or display an error when the form is submitted.
    const self = this
    this.sepaForm.addEventListener("submit", function (event) {
      event.preventDefault()

      var sourceData = {
        type: "sepa_debit",
        currency: "eur",
        owner: {
          name: this.sepa_name.value,
          email: this.sepa_email.value,
        },
        mandate: {
          // Automatically send a mandate notification email to your customer
          // once the source is charged.
          notification_method: "email",
        },
      }

      // Call `stripe.createSource` with the IBAN Element and additional IbanOptions.
      stripe.createSource(iban, sourceData).then((result) => {
        if (result.error) {
          // Inform the customer that there was an error.
          var errorElement = document.getElementById("sepa-errors")
          errorElement.textContent = result.error.message
          $("input[type=submit]", sepaForm)[0].removeAttribute("disabled")
        } else {
          // Send the Source to the server.
          self._addSourceTokenToForm(result.source)
        }
      })
    })

    this.creditCardForm.addEventListener("submit", (event) => {
      event.preventDefault()
      stripe.createToken(card).then((result) => {
        if (result.error) {
          // Inform the customer that there was an error.
          var errorElement = document.getElementById("card-errors")
          errorElement.textContent = result.error.message

          $(":submit", event.form)[0].removeAttribute("disabled")
        } else {
          // Send the token to your server.
          this._addSourceTokenToForm(result.token)
        }
      })
    })
  }

  _addSourceTokenToForm(sourceToken) {
    // Insert the Source ID into the form so it gets submitted to the server.
    var hiddenInput = document.createElement("input")
    hiddenInput.setAttribute("type", "hidden")
    hiddenInput.setAttribute("name", "subscription[stripeSource]")
    hiddenInput.setAttribute("value", sourceToken.id)
    this.subscriptionForm.appendChild(hiddenInput)

    // Submit the form.
    this.subscriptionForm.submit()
  }
}

export { PaymentController }
